import mod from "-!./InputPhone.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./InputPhone.js?vue&type=script&lang=js&external"